/** List of available account sub-types. */
export const accountSubTypes = [
  'basic',
  'bonus',
  'black',
  'swiss5',
  'swiss8',
  'swiss11',
  'classic',
  'swiss4',
  'ib_wallet',
  'ai',
  'master',
  'sub',
  'sc_sub',
  'bonds',
  'aff001',
  'aff002',
  'raw_trial',
  'raw_grow',
  'raw_pro',
  'raw',
  'invest_plus',
  'premium',
  'cent',
  'mt5Vip',
  'mt5Raw',
  'mt5Std',
  'mt5StdDemo',
] as const
